import { inject, Pipe, PipeTransform } from '@angular/core';
import { Supplement } from '@lx/shared/data-access/course';
import { DurationUnitsService as EslDurationService } from '../../shared/services/duration-units.service';

/**
 * Extracts and formats the duration unit text from a supplement's first optional.
 * Returns the "per duration" text (e.g., "per week", "per lesson") only if it's not already in the supplement name.
 *
 * @example
 * {{ supplement | supplementDurationUnit }} // "per week" or null
 */
@Pipe({
  standalone: true,
  name: 'lxSupplementDurationUnit',
})
export class SupplementDurationUnitPipe implements PipeTransform {
  private readonly durationService = inject(EslDurationService);

  transform(supplement: Supplement | null | undefined): string | null {
    const firstOptional = supplement?.optionals?.[0];
    if (!firstOptional?.durationUnit) {
      return null;
    }

    const durationUnitText = this.durationService.getPerDurationText(firstOptional.durationUnit, firstOptional.afterFixedPrice);

    if (!durationUnitText) {
      return null;
    }

    const alreadyInName = supplement.name?.toLowerCase().includes(durationUnitText.toLowerCase());
    return alreadyInName ? null : durationUnitText;
  }
}
